/* eslint-disable */
import React from 'react';
import {Modal, View, Text, StyleSheet} from 'react-native';
import Svg, {Path} from 'react-native-svg';
import PrimaryButton from './PrimaryButton';
import {colors, radii, shadows, spacing, typography} from '../config/theme';

export const LogoutConfirm = ({modalVisible, setModalVisible, onConfirm}) => {
  const handleCancel = () => {
    setModalVisible(false);
  };

  const handleConfirm = () => {
    onConfirm && onConfirm();
    setModalVisible(false);
  };

  return (
    <Modal
      animationType="fade"
      visible={!!modalVisible}
      transparent={true}
      statusBarTranslucent
      onRequestClose={handleCancel}>
      <View style={styles.backdrop}>
        <View style={styles.sheet}>
          <View style={styles.iconBackdrop}>
            <Svg
              width={26}
              height={26}
              viewBox="0 0 24 24"
              fill="none"
              stroke={colors.error}
              strokeWidth={1.8}
              strokeLinecap="round"
              strokeLinejoin="round">
              <Path d="M9 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h4M16 17l5-5-5-5M21 12H9" />
            </Svg>
          </View>
          <Text style={styles.title}>Do you want to logout?</Text>
          <View style={styles.buttons}>
            <PrimaryButton
              title="Confirm"
              variant="danger"
              onPress={handleConfirm}
            />
            <PrimaryButton
              title="Cancel"
              variant="secondary"
              onPress={handleCancel}
            />
          </View>
        </View>
      </View>
    </Modal>
  );
};

const styles = StyleSheet.create({
  backdrop: {
    flex: 1,
    backgroundColor: colors.overlay,
    alignItems: 'center',
    justifyContent: 'center',
    paddingHorizontal: spacing.margin,
  },
  sheet: {
    width: '100%',
    maxWidth: 400,
    backgroundColor: colors.surface,
    borderRadius: radii.sheet,
    padding: spacing.lg,
    paddingTop: spacing.xl,
    alignItems: 'center',
    ...shadows.level2,
  },
  iconBackdrop: {
    width: 56,
    height: 56,
    borderRadius: radii.pill,
    backgroundColor: colors.errorContainer,
    alignItems: 'center',
    justifyContent: 'center',
    marginBottom: spacing.margin,
  },
  title: {
    ...typography.headlineSm,
    color: colors.text,
    textAlign: 'center',
  },
  buttons: {
    marginTop: spacing.xl,
    width: '100%',
    gap: spacing.md,
  },
  // Destructive: error fill, error-tinted shadow.
});

export default LogoutConfirm;
